import type { HomeProps } from "./Home"

// Home content and settings (from the Framer canvas).
// tone: its main colour (shown behind it while it loads, if that takes a while)
const image = (id: string, w: number, h: number, tone?: string) => {
    const q = `width=${w}&height=${h}`
    const steps = [512, 1024, 2048, 4096].filter((s) => s < Math.max(w, h))
    const base = `https://framerusercontent.com/images/${id}`
    return {
        src: `${base}?${q}`,
        srcSet: [...steps.map((s) => `${base}?scale-down-to=${s}&${q} ${Math.round((s / Math.max(w, h)) * w)}w`), `${base}?${q} ${w}w`].join(","),
        alt: "",
        tone,
    }
}

/** one of the tiles hosted here: public/home/<name>-1280|2560.webp (2560 x 1400);
 *  phone: a version reframed for the phone's squarer tile (Figma, "mobile"),
 *  public/home/<name>-m-700|1400.webp (1400 x 1400), shown on phones only */
const own = (name: string, tone: string, phone = false) => ({
    src: `/home/${name}-1280.webp`,
    srcSet: `/home/${name}-1280.webp 1280w, /home/${name}-2560.webp 2560w`,
    alt: "",
    tone,
    ...(phone && { mobile: { src: `/home/${name}-m-700.webp`, srcSet: `/home/${name}-m-700.webp 700w, /home/${name}-m-1400.webp 1400w` } }),
})

export const HOME: HomeProps = {
    // slots 1-4 also play in the intro (wipes 3, 2, 1 over image 4)
    images: {
        1: image("ogv9KmQ4NjmyorDULVGzu8H7sQ.png", 4306, 2412, "#1884b8"),
        2: image("zTBDW3E2PAvWzodFYBlr4YKTA.png", 3184, 1906, "#a71803"),
        3: image("jqL0nQ8qtobvNAJGanKbvZrBIs.png", 1764, 964, "#050101"),
        4: image("5M2VrhkUeXyN9EvTrrf2jyMPQ.png", 3828, 2296, "#010105"),
        // (Figma "home_tiles", hosted here)
        5: own("bugaboo", "#f1c742"),
        6: own("zipper", "#b0c8e3"),
        7: own("klm", "#1f5f94", true),
        8: own("lufthansa", "#8f98a8", true),
        9: own("formula-e", "#e2e4e7", true),
        10: own("lego-mario", "#0100ab"),
        11: own("dept-festival", "#a76734", true),
        12: own("the-sub", "#00b95c", true),
        13: own("car-specs", "#131719"),
        14: own("smart", "#1110ec"),
    },
    reelUrl: "",
    workUrl: "/sports",
    background: "rgb(233, 233, 233)",
    reelColor: "rgb(77, 54, 255)",
    autoSpeed: 6,
    startDelay: 0,
    motionBlur: 0.65,
    videoSpeed: 0.1,
}
